import AttachmentItem from "./AttachmentItem";

export default AttachmentItem;
